import { Feature, GeoJSON } from 'geojson';
import { AbstractDrawCircle } from '../abstract-draw-circle';

export class EditorDrawCircle extends AbstractDrawCircle {
  display(state: any, geojson: GeoJSON & Feature, display: (geojson: GeoJSON) => void): any {
    switch (geojson.geometry.type) {
      case 'Polygon':
      case 'MultiPolygon':
        geojson.properties._showArea = this.controller.interaction.hasArea();
        geojson.properties._showVertexLength = this.controller.interaction.hasVertexLength();
        geojson.properties._showAngle = this.controller.interaction.hasAngle();
        if (!state.useOutlineSelect) {
          break;
        }
        let layerGeometry = this.controller.interaction.getLayerGeometry(geojson.properties.id);
        if (layerGeometry?.document) {
          geojson.properties.selection = layerGeometry.document.properties.selection ?? 'fill'; /* || 'outline' */
          geojson.properties.focusStyle = !!layerGeometry.document.properties?.styleFocus?.isActive;
        }
        break;
      case 'LineString':
      case 'MultiLineString':
        geojson.properties._showLength = this.controller.interaction.hasLength();
        geojson.properties._showVertexLength = this.controller.interaction.hasVertexLength();
        geojson.properties._showAngle = this.controller.interaction.hasAngle();
        break;
    }
    return super.display(state, geojson, display);
  }
}
